module.exports = __webpack_public_path__ + "img/baoxiao.5b85be64.jpg";